// ✅ Auto-generated Bootstrap4 components index
import BS4_Alerts from './bootstrap4_components/BS4_Alerts.jsx';
import BS4_AllClasses from './bootstrap4_components/BS4_AllClasses.jsx';
import BS4_Badges from './bootstrap4_components/BS4_Badges.jsx';
import BS4_BasicTemplate from './bootstrap4_components/BS4_BasicTemplate.jsx';
import BS4_ButtonGroups from './bootstrap4_components/BS4_ButtonGroups.jsx';
import BS4_Buttons from './bootstrap4_components/BS4_Buttons.jsx';
import BS4_Cards from './bootstrap4_components/BS4_Cards.jsx';
import BS4_Carousel from './bootstrap4_components/BS4_Carousel.jsx';
import BS4_Certificate from './bootstrap4_components/BS4_Certificate.jsx';
import BS4_Collapse from './bootstrap4_components/BS4_Collapse.jsx';
import BS4_Colors from './bootstrap4_components/BS4_Colors.jsx';
import BS4_Containers from './bootstrap4_components/BS4_Containers.jsx';
import BS4_CustomForms from './bootstrap4_components/BS4_CustomForms.jsx';
import BS4_Dropdowns from './bootstrap4_components/BS4_Dropdowns.jsx';
import BS4_Editor from './bootstrap4_components/BS4_Editor.jsx';
import BS4_Exercises from './bootstrap4_components/BS4_Exercises.jsx';
import BS4_Filters from './bootstrap4_components/BS4_Filters.jsx';
import BS4_Flex from './bootstrap4_components/BS4_Flex.jsx';
import BS4_Forms from './bootstrap4_components/BS4_Forms.jsx';
import BS4_GetStarted from './bootstrap4_components/BS4_GetStarted.jsx';
import BS4_GridBasic from './bootstrap4_components/BS4_GridBasic.jsx';
import BS4_GridExamples from './bootstrap4_components/BS4_GridExamples.jsx';
import BS4_GridLarge from './bootstrap4_components/BS4_GridLarge.jsx';
import BS4_GridMedium from './bootstrap4_components/BS4_GridMedium.jsx';
import BS4_GridSmall from './bootstrap4_components/BS4_GridSmall.jsx';
import BS4_GridSystem from './bootstrap4_components/BS4_GridSystem.jsx';
import BS4_GridXLarge from './bootstrap4_components/BS4_GridXLarge.jsx';
import BS4_GridXSmall from './bootstrap4_components/BS4_GridXSmall.jsx';
import BS4_Home from './bootstrap4_components/BS4_Home.jsx';
import BS4_Icons from './bootstrap4_components/BS4_Icons.jsx';
import BS4_Images from './bootstrap4_components/BS4_Images.jsx';
import BS4_InputGroups from './bootstrap4_components/BS4_InputGroups.jsx';
import BS4_Inputs from './bootstrap4_components/BS4_Inputs.jsx';
import BS4_InterviewPrep from './bootstrap4_components/BS4_InterviewPrep.jsx';
import BS4_JS_Alert from './bootstrap4_components/BS4_JS_Alert.jsx';
import BS4_JS_Button from './bootstrap4_components/BS4_JS_Button.jsx';
import BS4_JS_Carousel from './bootstrap4_components/BS4_JS_Carousel.jsx';
import BS4_JS_Collapse from './bootstrap4_components/BS4_JS_Collapse.jsx';
import BS4_JS_Dropdown from './bootstrap4_components/BS4_JS_Dropdown.jsx';
import BS4_JS_Modal from './bootstrap4_components/BS4_JS_Modal.jsx';
import BS4_JS_Popover from './bootstrap4_components/BS4_JS_Popover.jsx';
import BS4_JS_Scrollspy from './bootstrap4_components/BS4_JS_Scrollspy.jsx';
import BS4_JS_Tab from './bootstrap4_components/BS4_JS_Tab.jsx';
import BS4_JS_Toasts from './bootstrap4_components/BS4_JS_Toasts.jsx';
import BS4_JS_Tooltip from './bootstrap4_components/BS4_JS_Tooltip.jsx';
import BS4_Jumbotron from './bootstrap4_components/BS4_Jumbotron.jsx';
import BS4_ListGroups from './bootstrap4_components/BS4_ListGroups.jsx';
import BS4_MediaObjects from './bootstrap4_components/BS4_MediaObjects.jsx';
import BS4_Modal from './bootstrap4_components/BS4_Modal.jsx';
import BS4_Navbar from './bootstrap4_components/BS4_Navbar.jsx';
import BS4_Navs from './bootstrap4_components/BS4_Navs.jsx';
import BS4_Pagination from './bootstrap4_components/BS4_Pagination.jsx';
import BS4_Popover from './bootstrap4_components/BS4_Popover.jsx';
import BS4_ProgressBars from './bootstrap4_components/BS4_ProgressBars.jsx';
import BS4_Quiz from './bootstrap4_components/BS4_Quiz.jsx';
import BS4_Scrollspy from './bootstrap4_components/BS4_Scrollspy.jsx';
import BS4_Spinners from './bootstrap4_components/BS4_Spinners.jsx';
import BS4_StackedHorizontal from './bootstrap4_components/BS4_StackedHorizontal.jsx';
import BS4_Tables from './bootstrap4_components/BS4_Tables.jsx';
import BS4_Toast from './bootstrap4_components/BS4_Toast.jsx';
import BS4_Tooltip from './bootstrap4_components/BS4_Tooltip.jsx';
import BS4_Typography from './bootstrap4_components/BS4_Typography.jsx';
import BS4_Utilities from './bootstrap4_components/BS4_Utilities.jsx';

const bootstrap4ComponentsMap = {
  "<BS4_Alerts />": BS4_Alerts,
  "<BS4_AllClasses />": BS4_AllClasses,
  "<BS4_Badges />": BS4_Badges,
  "<BS4_BasicTemplate />": BS4_BasicTemplate,
  "<BS4_ButtonGroups />": BS4_ButtonGroups,
  "<BS4_Buttons />": BS4_Buttons,
  "<BS4_Cards />": BS4_Cards,
  "<BS4_Carousel />": BS4_Carousel,
  "<BS4_Certificate />": BS4_Certificate,
  "<BS4_Collapse />": BS4_Collapse,
  "<BS4_Colors />": BS4_Colors,
  "<BS4_Containers />": BS4_Containers,
  "<BS4_CustomForms />": BS4_CustomForms,
  "<BS4_Dropdowns />": BS4_Dropdowns,
  "<BS4_Editor />": BS4_Editor,
  "<BS4_Exercises />": BS4_Exercises,
  "<BS4_Filters />": BS4_Filters,
  "<BS4_Flex />": BS4_Flex,
  "<BS4_Forms />": BS4_Forms,
  "<BS4_GetStarted />": BS4_GetStarted,
  "<BS4_GridBasic />": BS4_GridBasic,
  "<BS4_GridExamples />": BS4_GridExamples,
  "<BS4_GridLarge />": BS4_GridLarge,
  "<BS4_GridMedium />": BS4_GridMedium,
  "<BS4_GridSmall />": BS4_GridSmall,
  "<BS4_GridSystem />": BS4_GridSystem,
  "<BS4_GridXLarge />": BS4_GridXLarge,
  "<BS4_GridXSmall />": BS4_GridXSmall,
  "<BS4_Home />": BS4_Home,
  "<BS4_Icons />": BS4_Icons,
  "<BS4_Images />": BS4_Images,
  "<BS4_InputGroups />": BS4_InputGroups,
  "<BS4_Inputs />": BS4_Inputs,
  "<BS4_InterviewPrep />": BS4_InterviewPrep,
  "<BS4_JS_Alert />": BS4_JS_Alert,
  "<BS4_JS_Button />": BS4_JS_Button,
  "<BS4_JS_Carousel />": BS4_JS_Carousel,
  "<BS4_JS_Collapse />": BS4_JS_Collapse,
  "<BS4_JS_Dropdown />": BS4_JS_Dropdown,
  "<BS4_JS_Modal />": BS4_JS_Modal,
  "<BS4_JS_Popover />": BS4_JS_Popover,
  "<BS4_JS_Scrollspy />": BS4_JS_Scrollspy,
  "<BS4_JS_Tab />": BS4_JS_Tab,
  "<BS4_JS_Toasts />": BS4_JS_Toasts,
  "<BS4_JS_Tooltip />": BS4_JS_Tooltip,
  "<BS4_Jumbotron />": BS4_Jumbotron,
  "<BS4_ListGroups />": BS4_ListGroups,
  "<BS4_MediaObjects />": BS4_MediaObjects,
  "<BS4_Modal />": BS4_Modal,
  "<BS4_Navbar />": BS4_Navbar,
  "<BS4_Navs />": BS4_Navs,
  "<BS4_Pagination />": BS4_Pagination,
  "<BS4_Popover />": BS4_Popover,
  "<BS4_ProgressBars />": BS4_ProgressBars,
  "<BS4_Quiz />": BS4_Quiz,
  "<BS4_Scrollspy />": BS4_Scrollspy,
  "<BS4_Spinners />": BS4_Spinners,
  "<BS4_StackedHorizontal />": BS4_StackedHorizontal,
  "<BS4_Tables />": BS4_Tables,
  "<BS4_Toast />": BS4_Toast,
  "<BS4_Tooltip />": BS4_Tooltip,
  "<BS4_Typography />": BS4_Typography,
  "<BS4_Utilities />": BS4_Utilities,
};

export default bootstrap4ComponentsMap;
